export default "__VITE_ASSET__Cgx1HtDx__ 640w, __VITE_ASSET___cZOwAQS__ 1024w";